var stores = require('../locations/locations.json');

// console.log('Data');
// console.log(stores);
/*const stores = [
    { name: "Store 1", lat: 40.7128, lng: -74.0060 },
    { name: "Store 2", lat: 34.0522, lng: -118.2437 },
    { name: "Store 3", lat: 41.8781, lng: -87.6298 }
];*/

navigator.geolocation.getCurrentPosition(successCallback, errorCallback);

function successCallback(position) {
    const userLat = position.coords.latitude;
    const userLng = position.coords.longitude;
    let closestStore = findClosestStore(userLat, userLng);
    console.log('Closest Store: ' + closestStore.acf.address_line_1);



    /*setTimeout(() => {
        jQuery('#termsearch').val(closestStore.acf.address_line_1);
    }, 200);
*/
}

function errorCallback(error) {
    console.error("Error getting location: ", error);
}

function getDistance(lat1, lng1, lat2, lng2) {
    function toRad(x) {
        return x * Math.PI / 180;
    }

    const R = 6371; // Earth's radius in km
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function findClosestStore(userLat, userLng) {
    let closestStore = null;
    let shortestDistance = Infinity;

    stores.forEach(store => {
        const distance = getDistance(userLat, userLng, store.acf.latitude, store.acf.longitude);
        if (distance < shortestDistance) {
            shortestDistance = distance;
            closestStore = store;
        }
    });

    console.log("Closest Store: ", closestStore);
    return closestStore;
}

function showClosestStoreOnMap(map, closestStore) {
    new google.maps.Marker({
        position: { lat: closestStore.lat, lng: closestStore.lng },
        map: map,
        title: closestStore.name
    });
}
